import { render, staticRenderFns } from "./CapabilityTicklist.vue?vue&type=template&id=4277648b&scoped=true&"
import script from "./CapabilityTicklist.vue?vue&type=script&lang=js&"
export * from "./CapabilityTicklist.vue?vue&type=script&lang=js&"
import style0 from "./CapabilityTicklist.vue?vue&type=style&index=0&id=4277648b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4277648b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
